<div class="side-bar">
  <!-- [ngClass]="{'ie11': isIE11}"> -->
  <div class="side-bar-title">{{'mkb.card3dsecure.side.bar.title' | resolve}}</div>
  <div>
    <div class="contact-wrapper">
      <div class="contact-icon">
        <img class="bitmap-icon" src="assets/icons/start_call_icon.svg" />
      </div>
      <a [href]="clickToCallHref" sessionReviveClick>
        {{clickToCall}}
      </a>
    </div>
    <mat-divider></mat-divider>
    <div class="contact-wrapper">
      <div class="contact-icon">
        <img class="bitmap-icon" src="assets/icons/send_mail_icon.svg" />
      </div>
      <a target="_blank" [href]="startChat" sessionReviveClick>
        {{'mkb.card3dsecure.side.bar.chat.title' | resolve}}
      </a>
    </div>
    <mat-divider></mat-divider>
    <div class="contact-wrapper">
      <div class="contact-icon">
        <img class="bitmap-icon" src="assets/icons/call_back_icon.svg" />
      </div>
      <a target="_blank" [href]="callBack" sessionReviveClick>
        {{'mkb.card3dsecure.side.bar.callback.title' | resolve}}
      </a>
    </div>
    <mat-divider></mat-divider>
  </div>
</div>
